import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./DashBoard.css"

const DashBoard = () => {
  const [tasks, setTasks] = useState([]);
  const [data, setData] = useState([]);


  const fetchData = () => {
    fetch("https://taskpri.hariombusinessenterprise.com/fetch_data.php")
      .then(response => response.json())
      .then(data => {
        setData(data);
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  };

useEffect(() => {
  fetchData();
}, []);


  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    client_flag: "",
    tasks: "",
    deadline: "",
    weightage: "",
    day_to_schedule: "",
  });

  const handleInsert = async (task, isChecked) => {
    const confirmInsert = window.confirm(
      `Do you want to add  the task "${task.tasks}" as complete?`
    );
  
    if (!confirmInsert) {
      return; // Stop execution if the user cancels
    }
  
    try {
      const response = await fetch("https://taskpri.hariombusinessenterprise.com/insert_task.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          complete_id: isChecked ? 1 : 0,  // 1 if checked, 0 if unchecked
          task: task.tasks,
          weightage: task.weightage,
          deadline: task.deadline,
          day_to_schedule: task.day_to_schedule,
          client_flag: task.client_flag,
        }),
        
      });
  
      const data = await response.json();
      alert(data.message || data.error);
      fetchData();
    } catch (error) {
      console.error("Error inserting task:", error);
    }
  };
  



  // Fetch tasks from the database
  const fetchTasks = async () => {
    try {
      const response = await fetch("https://taskpri.hariombusinessenterprise.com/get_tasks.php");
      const data = await response.json();
  
      // Sort based on multiple conditions
      const sortedTasks = data.sort((a, b) => {
        // 1. Client Flag (client_flag = 1 has higher priority)
        if (b.client_flag !== a.client_flag) {
          return b.client_flag - a.client_flag;
        }
        // 2. Higher weightage first
        if (b.weightage !== a.weightage) {
          return b.weightage - a.weightage;
        }
        // 3. Earlier deadline first
        if (a.deadline !== b.deadline) {
          return a.deadline - b.deadline;
        }
        // 4. Lower "day to schedule" first
        if (a.day_to_schedule !== b.day_to_schedule) {
          return a.day_to_schedule - b.day_to_schedule;
        }
        // 5. Older timestamp first (earlier created task goes on top)
        return new Date(a.timestamp) - new Date(b.timestamp);
      });
  
      setTasks(sortedTasks);
      console.log("Fetched and sorted tasks:", sortedTasks);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };
  

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle task submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://taskpri.hariombusinessenterprise.com/add_task.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      alert(result.message);
      if (result.success) {
        setFormData({ client_flag: "", tasks: "", deadline: "", weightage: "", day_to_schedule: "" });
        fetchTasks(); // Refresh task list
      }
    } catch (error) {
      console.error("Error adding task:", error);
    }
  };

  // Handle task deletion using `tasks` as identifier
  const handleDelete = async (taskName) => {
    try {
      const response = await fetch("https://taskpri.hariombusinessenterprise.com/delete_task.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tasks: taskName }),
      });

      const result = await response.json();
      alert(result.message);
      if (result.success) {
        fetchTasks(); // Refresh task list
      }
    } catch (error) {
      console.error("Error deleting task:", error);
    }
  };

  // Fetch tasks on component mount
  useEffect(() => {
    fetchTasks();
  }, []);

  return (
    <div className="container">
      <h2>Task Manager</h2>
      <button onClick={() => navigate("/")}>Home</button>
      
      {/* Form to Add Task */}
      <form onSubmit={handleSubmit}>
        <input type="number" name="client_flag" placeholder="Client Flag" value={formData.client_flag} onChange={handleChange} required />
        <input type="text" name="tasks" placeholder="Task Name" value={formData.tasks} onChange={handleChange} required />
        <input type="number" name="deadline" placeholder="Deadline" value={formData.deadline} onChange={handleChange} required />
        <input type="number" name="weightage" placeholder="Weightage" value={formData.weightage} onChange={handleChange} required />
        <input type="number" name="day_to_schedule" placeholder="Day to Schedule" value={formData.day_to_schedule} onChange={handleChange} required />
        <button type="submit">Add Task</button>
      </form>

      {/* Task List */}
      <table className="task-table">
  <thead>
    <tr>
      <th>Complete</th>
      <th>Task</th>
      <th>Weightage</th>
      <th>Deadline</th>
      <th>Schedule</th>
      <th>Client Flag</th>
      <th>Remove</th>
    </tr>
  </thead>
  <tbody>
  {tasks.map((task) => {
  const isChecked = data.some((row) => row.Task === task.tasks); // Check if task exists in data

  return (
    <tr key={task.tasks}>
      <td>
        <input
          type="checkbox"
          checked={isChecked} // Default checked if matched
          onChange={(e) => handleInsert(task, e.target.checked)}
        />
      </td>
      <td>{task.tasks}</td>
      <td>{task.weightage}</td>
      <td>{task.deadline}</td>
      <td>{task.day_to_schedule}</td>
      <td>{task.client_flag}</td>
      <td>
        <button onClick={() => handleDelete(task.tasks)}>Delete</button>
      </td>
    </tr>
  );
})}

      </tbody>
</table>


<div>
      <h2> complete Task List</h2>
      <table className="task-table"  border="1">
        <thead>
          <tr>
            <th>Complete ID</th>
            <th>Task</th>
            <th>Weightage</th>
            <th>Deadline</th>
            <th>Schedule</th>
            <th>Client Flag</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.complete_id}</td>
              <td>{row.Task}</td>
              <td>{row.Weightage}</td>
              <td>{row.Deadline}</td>
              <td>{row.Schedule}</td>
              <td>{row.Client_Flag}</td>
              <td>{row.created_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>


    </div>
  );
};

export default DashBoard;



